/* 🤖 this file was generated by svg-to-ts */
export const matIconDoNotDisturbOn: {
  name: 'do-not-disturb-on';
  data: string;
} = {
  name: 'do-not-disturb-on',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>`
};
